import { render, staticRenderFns } from "./orders.vue?vue&type=template&id=56ccc202&scoped=true"
import script from "./orders.vue?vue&type=script&lang=js"
export * from "./orders.vue?vue&type=script&lang=js"
import style0 from "./orders.vue?vue&type=style&index=0&id=56ccc202&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ccc202",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/fe/mewo-website-vue-hmt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56ccc202')) {
      api.createRecord('56ccc202', component.options)
    } else {
      api.reload('56ccc202', component.options)
    }
    module.hot.accept("./orders.vue?vue&type=template&id=56ccc202&scoped=true", function () {
      api.rerender('56ccc202', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orders.vue"
export default component.exports